import "./basicInfo.scss";

interface IBasicInfo {
  title: string;
  data: string;
  type?: string;
}

export default function BasicInfo({ title, data, type }: IBasicInfo) {
  const isYouTubeUrl =
    type === "url" &&
    data &&
    (data.includes("youtube.com") || data.includes("youtu.be"));

  const getVideoId = (url: string) => {
    const regex =
      /(?:youtube\.com\/(?:watch\?v=|shorts\/)|youtu\.be\/)([^"&?/\s]{11})/;
    const match = url.match(regex);
    return match ? match[1] : null;
  };

  const videoId = isYouTubeUrl ? getVideoId(data) : null;
  const embedUrl = videoId ? `https://www.youtube.com/embed/${videoId}` : null;

  return (
    <div className="text-info-wrapper">
      {type !== "url" && <div className="text-pad-left">{title}</div>}

      {embedUrl && (
        <div className="iframe-wrapper">
          <iframe
            src={embedUrl}
            title="YouTube video player"
            frameBorder="0"
            allow="autoplay; encrypted-media"
            allowFullScreen
          ></iframe>
        </div>
      )}

      <div className="chip-wrapper">
        {isYouTubeUrl ? (
          <a href={data} className="chip-link" target="_blank" rel="noreferrer">
            {data}
          </a>
        ) : (
          data
        )}
      </div>
    </div>
  );
}
